import { AbstractCommand } from 'src/models/command';

class RemoveReceiverGroupMemberCommand extends AbstractCommand {
	override readonly async = false;
	readonly name = 'IFS_Mail_Command_Command_RemoveReceiverGroupMemberCommand';

	public constructor(groupId: number, memberId: number) {
		super();
		this.parameters = {
			groupId: groupId,
			memberId: memberId,
		};
	}
}

export { RemoveReceiverGroupMemberCommand };
